import { render } from "./terms-condition.vue?vue&type=template&id=a0c35f36"
import script from "./terms-condition.vue?vue&type=script&lang=js"
export * from "./terms-condition.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__